import en from '@/i18n/en/index'

const lang = { en }

export default lang
